import { render } from "./QuickFact.vue?vue&type=template&id=6ec39f7c&scoped=true"
import script from "./QuickFact.vue?vue&type=script&lang=js"
export * from "./QuickFact.vue?vue&type=script&lang=js"

import "./QuickFact.vue?vue&type=style&index=0&id=6ec39f7c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src775359160/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec39f7c"]])

export default __exports__